/* Tanvika — Latest drop
   Dot pagination synced to each card's image strip, plus a local save toggle.

   The strip is a native scroll-snap container, so swipe and trackpad work with
   no JavaScript at all. This only keeps the dots in step and lets them be
   clicked — if it never runs, the section still scrolls and still reads. */

(function () {
  'use strict';

  function initGallery(media) {
    var strip = media.querySelector('[data-tv-slides]');
    var dots = Array.prototype.slice.call(media.querySelectorAll('[data-tv-dot]'));
    if (!strip || dots.length < 2) return;

    var ticking = false;

    function sync() {
      // Round rather than floor: at a snap point the scroll position can sit a
      // fraction under the slide boundary, which would keep the previous dot lit.
      var index = Math.round(strip.scrollLeft / strip.clientWidth);
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      ticking = false;
    }

    strip.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(sync);
      },
      { passive: true }
    );

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        strip.scrollTo({ left: strip.clientWidth * i, behavior: 'smooth' });
      });
    });

    sync();
  }

  // Saved items are kept locally. This is a genuine local marker, not a
  // customer-account wishlist — it does not follow the shopper to another
  // device. Swap for a wishlist app's API if one is ever installed.
  var STORE_KEY = 'tv-saved';

  function readSaved() {
    try {
      return JSON.parse(localStorage.getItem(STORE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function writeSaved(list) {
    try {
      localStorage.setItem(STORE_KEY, JSON.stringify(list));
    } catch (e) {
      /* private mode, quota — the toggle just will not persist */
    }
  }

  function initSave(button) {
    var handle = button.getAttribute('data-tv-save');
    if (!handle) return;

    var saved = readSaved();
    button.setAttribute('aria-pressed', saved.indexOf(handle) > -1 ? 'true' : 'false');

    button.addEventListener('click', function () {
      var list = readSaved();
      var at = list.indexOf(handle);
      if (at > -1) {
        list.splice(at, 1);
        button.setAttribute('aria-pressed', 'false');
      } else {
        list.push(handle);
        button.setAttribute('aria-pressed', 'true');
      }
      writeSaved(list);
    });
  }

  function init() {
    document.querySelectorAll('[data-tv-media]').forEach(initGallery);
    document.querySelectorAll('[data-tv-save]').forEach(initSave);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Re-run when the theme editor re-renders the section.
  document.addEventListener('shopify:section:load', init);
})();
